// extracted by mini-css-extract-plugin
export default {"notification-dot-container":"NotificationDot_notification-dot-container__8o6jy","notification-dot":"NotificationDot_notification-dot__0tyzl"};